<template>
  <div>
    <Button
      :size="15"
      color="#2da44e"
      colorText="#ffffff"
      tooltip="Agregar Módulo"
      icon="fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      @click.native="openModal('modal')"
    />

    <ui-modal ref="modal" title="Agregar Módulo">
      <div class="d-flex">
        <ui-textbox
          class="w-100 mr-3"
          floating-label
          label="Nombre"
          v-model="formulario.nombreModel"
        />
        <ui-textbox
          class="w-100"
          floating-label
          label="Ícono"
          v-model="formulario.iconoModel"
        />
      </div>
      <div class="d-flex">
        <div class="w-100 mr-3"></div>
        <div class="d-flex w-100">
          <div class="w-75"><h6>Ícono seleccionado:</h6></div>
          <div class="w-25" v-if="formulario.iconoModel.length > 0">
            <i :class="formulario.iconoModel" style="font-size: 18pt"></i>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="validarFormulario">
          Guardar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";

// Buttom
import Button from "../../../common/Button";

// Constantes
import {
  saveModulos,
  getModulos,
} from "../../../../constants/superadministrador";

export default {
  data() {
    return {
      formulario: {
        nombreModel: "",
        iconoModel: "",
      },
    };
  },
  components: {
    UiModal,
    UiTextbox,
    Button,
  },
  methods: {

    ...mapActions("superadministrador", ["actionSetDataModulos"]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    
    closeModal(ref) {
      this.$refs[ref].close();
    },

    validarFormulario() {
      if (
        this.formulario.nombreModel != "" ||
        this.formulario.iconoModel != ""
      ) {
        this.guardar();
      } else {
        this.$vToastify.error("Campos sin completar", "¡Error!");
      }
    },

    async guardar() {
      let sql = await saveModulos(this.formulario);

      if (!sql.error) {
        // Toast proceso exitoso
        this.$vToastify.success("Módulo creado con éxito", "¡Realizado");

        // Limpiar variables
        this.formulario.nombreModel = "";
        this.formulario.iconoModel = "";

        let dataModulosDB = await getModulos();
        this.data = dataModulosDB;

        this.actionSetDataModulos(dataModulosDB.data_table);

        // Cerrar Modal
        this.closeModal("modal");
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.error("El Módulo no pudo ser creado", "¡Error!");
        }
      }
    },
  },
};
</script>

<style></style>
